export const DataHooks = {
  Root: 'AddButton.Root',
} as const;
